<div class="ya-typography" (swiperight)="SwiperNavigateBack()">
  <ya-subheader class="ya-header-title-wrapper" [hasContent]="true"></ya-subheader>
  <div class="ya-page-content ya-page-content--webshop ya-page-content--inset ya-page-content--aligncenter">
    <div class="selection-content">
      <div class="info-content--top">
        <div class="icon-container">
          <div class="inline-icon"
            [inlineSVG]="isOrderDelivery?'shop-icons.svg#ya-hypersoft-liefern':'shop-icons.svg#ya-hypersoft-abholen'">
          </div>
        </div>
        <div class="info-item title-margin">
          <h2>{{selectTimeInfoTitle}}</h2>
        </div>
      </div>
      <div class="form__list">
        <div class="form-input_info">
          <p class="text">{{selectTimeSubText}}</p>
        </div>
        <div class="time-content" id="serviceDateContent">
          <ng-container *ngIf="dayList$|async;let dayList">
            <!-- Day selection -->
            <div class="selection">
              <span class="select-info">{{dayLabel}}</span>
              <div class="dropdown-container">
                <div class="input-container-flex">
                  <select a11y_Select class="ya-input-text" (change)="selectionChangeDay($event, dayList)">
                    <ng-container *ngFor="let day of dayList">
                      <option [(value)]="day.value" [selected]="isDayselected(day.value)">
                        {{ day.key }}
                      </option>
                    </ng-container>
                  </select>
                  <div class="inline-icon" inlineSVG="hypersoft-pfeil-unten-voll.svg"></div>
                </div>
              </div>
            </div>
            <!-- Time selection -->
            <div class="selection">
              <span class="select-info">{{timeLabel}}</span>
              <div class="dropdown-container">
                <div class="input-container-flex">
                  <ng-container *ngIf="serviceOpenTime$|async; let openTimes">
                    <select a11y_Select class="ya-input-text"
                      (change)="onTimeChange($event.currentTarget.value,openTimes)">
                      <ng-container *ngFor="let serviceTime of openTimes; let index = index">
                        <option [value]="index" [selected]="isTimeSelected(serviceTime)">
                          {{serviceTime.display}}</option>
                      </ng-container>
                    </select>
                  </ng-container>
                  <div class="inline-icon" inlineSVG="hypersoft-pfeil-unten-voll.svg"></div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="button-wrapper">
      <div class="ya-webshop-button-container">
        <ng-container *ngIf="setButtonActive() then activeButton else deactiveButton">
        </ng-container>
        <ng-template #activeButton>
          <button a11y_Button mat-flat-button type="submit" (click)="handleNavigation()">
            <span langkey="phGlobal_Continue"></span></button>
        </ng-template>
        <ng-template #deactiveButton>
          <button a11y_Button mat-flat-button disabled><span langkey="phGlobal_Continue"></span></button>
        </ng-template>
      </div>
    </div>
  </div>
</div>